import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IoArrowForward } from 'react-icons/io5';

const TokenCard = () => {
    const { t } = useTranslation();
    const [tokenData] = useState({
        symbol: t('tokenCard.symbol'),
        name: t('tokenCard.name'),
        description: t('tokenCard.description'),
        price: '0.028854',
        totalSupply: '10.00B',
        circulatingSupply: '2.55B',
        burnRate: '74.14%'
    });

    return (
        <div className="token-card">
            <div className="token-card-header">
                <div className="token-card-title">
                    <h2>
                        <span className="token-symbol">{tokenData.symbol}</span> {tokenData.name}
                    </h2>
                    <p className="token-description">{tokenData.description}</p>
                </div>
                <Link to="/market" className="token-card-link">
                    <IoArrowForward size={28} />
                </Link>
            </div>

            <div className="token-card-chart">
                <img src="/assets/images/token-grafik.png" alt="Token Chart" />
            </div>

            <div className="token-card-stats">
                <div className="stat-item">
                    <div className="stat-value">{tokenData.price}</div>
                    <div className="stat-label">{t('tokenCard.latestPrice')}</div>
                </div>
                <div className="stat-item">
                    <div className="stat-value">{tokenData.totalSupply}</div>
                    <div className="stat-label">{t('tokenCard.totalSupply')}({tokenData.symbol})</div>
                </div>
                <div className="stat-item">
                    <div className="stat-value">{tokenData.circulatingSupply}</div>
                    <div className="stat-label">{t('tokenCard.circulatingSupply')}({tokenData.symbol})</div>
                </div>
                <div className="stat-item">
                    <div className="stat-value">{tokenData.burnRate}</div>
                    <div className="stat-label">{t('tokenCard.burnRate')}</div>
                </div>
            </div>
        </div>
    );
};

export default TokenCard;
